import React from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';

const Modal = ({ children, modalControl, modalState, modalHeader, modalSubHeader, modalContentClosed, modalCloseControl, modalWidth }) => {

    const [modal, setModal] = useState(false)

    const handleClickAway = () => {
        setModal(false)
    }

    const animateModal = {
        initial: { opacity: 0, y: 500 },
        animate: { opacity: 1, y: 0 }, 
        exit: { opacity: 0, y: 500, transition: { duration: 0.3 } }
    }

    return (
        <div className={`fixed inset-0 z-front ${(modalState || modal) ? 'pointer-events-auto' : 'pointer-events-none '}`}>
            <AnimatePresence>
                { (modalState || modal) && (
                    <div>
                        <motion.div className="fixed inset-0  bg-black/50" exit={{opacity: 0}}></motion.div>
                            <div className="fixed inset-0  flex items-center justify-center">
                                <ClickAwayListener onClickAway={handleClickAway}>
                                        <motion.div 
                                            className='w-full sm:w-[50vw] relative max-w-screen-lg mx-2 overflow-y-auto bg-light rounded-card h-auto max-h-[83vh] p-6 md:p-8' 
                                            initial='initial' 
                                            animate='animate' 
                                            exit='exit' 
                                            variants={animateModal}
                                        >
                                            <div className='flex flex-col w-full mb-4'>
                                                {modalHeader != null &&
                                                    <h5 className='text-xl font-medium'>{modalHeader}</h5>
                                                }

                                                {modalSubHeader != null  &&
                                                    <p className='text-grey mt-2'>{modalSubHeader}</p>
                                                }
                                                
                                                { modal && (
                                                    <div 
                                                        onClick={() => setModal(false)} 
                                                        aria-label={`Close ${props.modalHeader}`}
                                                    >
                                                        {modalCloseControl}
                                                    </div>
                                                )}
                                               
                                            </div>
                                            <div>{children}</div>
                                        </motion.div>
                                </ClickAwayListener>
                            </div> 
                    </div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default Modal;